import { Component, inject } from '@angular/core';
import { BackboneComponent } from '@components/backbone/backbone.component';
import { BreadcrumbComponent } from '@components/breadcrumb/breadcrumb.component';
import { SessionService } from '@utils/session.service';

@Component({
  selector: 'app-home',
  imports: [BackboneComponent, BreadcrumbComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomePage {
  private sessionService = inject(SessionService);

  public user = this.sessionService.getUser();
}
